import { z } from 'zod';
export const ReplayRequestSchema = z.object({
    targetProjectorArn: z.string(),
    startAt: z.string().datetime().optional(),
    windowStart: z.number().optional(),
    windowCursor: z.number().optional(),
});
